// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"b0dfd035","884":"12ef49d5"}[chunkId] + ".chunk.js";
};